import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-card__content" }
const _hoisted_2 = { class: "c-card__title" }
const _hoisted_3 = { class: "c-card__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImagePoster = _resolveComponent("ImagePoster")!
  const _component_Label = _resolveComponent("Label")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.to,
    class: "c-card"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ImagePoster, {
        class: "c-card__image",
        image: _ctx.image,
        type: _ctx.type
      }, null, 8, ["image", "type"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dateFormatted), 1),
        (_ctx.mediaId)
          ? (_openBlock(), _createBlock(_component_Label, {
              key: 0,
              isCaption: true,
              variants: ['error'],
              text: _ctx.trans('general.viewing_available'),
              class: "c-card__label"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}